import { Injectable } from '@angular/core';
import { HttpClient} from '@angular/common/http';
import { Observable } from 'rxjs';
import { Role } from '../models/role';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class RolesService {
  // TODO: move this a config environment var
  baseUrl: string = environment.apiUrl;


  constructor(private HttpClient: HttpClient) {}


  /**
   * Retrieves all roles from the server.
   *
   * @returns An observable that emits an array of Role objects
   */
  getRoles(): Observable<Role[]> {
    return this.HttpClient.get<Role[]>(
      `${this.baseUrl}/roles`
    );
  }

  getRole(roleId: number): Observable<Role[]> {
    return this.HttpClient.get<Role[]>(
      `${this.baseUrl}/roles/`+ roleId
    );
  }

  delete_role(id: number): Observable<void> {
    return this.HttpClient.delete<void>(
      this.baseUrl + '/roles/' + id
    );
  }

  addRole(role : Role): Observable<Role> {
    return this.HttpClient.post<Role>(
      this.baseUrl + '/roles',
      role
    );
  }

  updateRole(role : Role): Observable<Role> {
    return this.HttpClient.put<Role>(
      this.baseUrl + '/roles/' + role.id,
      role
    );
  }
}
